import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EditleadComponent } from './editlead.component';
import { UserRoutingModule } from './agent.routes';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { HttpClientModule } from '@angular/common/http';
import { AppAgentComponent } from './app-agent/app-agent.component';
import { AppNavbarAgentComponent } from './app-navbar-agent/app-navbar-agent.component';
import { AppSidebarAgentComponent } from './app-sidebar-agent/app-sidebar-agent.component';
import { AppContentAgentComponent } from './app-content-agent/app-content-agent.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
import { ModalComponent } from './modal/modal.component';
import { AccountService } from 'src/app/core/api/account.service';
import { CompanyService } from 'src/app/shared/companyservice/company.service';

@NgModule({
  declarations: [EditleadComponent, AppAgentComponent, AppNavbarAgentComponent, AppSidebarAgentComponent, AppContentAgentComponent, DeleteConfirmationComponent, ModalComponent],
  imports: [
    CommonModule,
    UserRoutingModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    DropdownModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
providers: [ModalComponent ,AccountService,CompanyService], // Provide ModalComponent here
 
})
export class AgentModule { }

